<app-svg-icon
  *ngIf="dataLayerType.icon"
  [key]="dataLayerType.icon"></app-svg-icon>
<i
  *ngIf="!dataLayerType.icon"
  [class]="
    dataLayerType.type === 'Polygon'
      ? 'fa-regular fa-map'
      : dataLayerType.type === 'Point'
        ? 'fas fa-location-dot'
        : 'fas fa-map-pin'
  "></i>
